module.exports = __webpack_public_path__ + "images/wertentwicklung_neg_FBB.svg.svg?cca13cf03a92988469d7c6678ff3a6bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/wertentwicklung_neg_FBB.svg.svg
// module id = jwow
// module chunks = 0